import styled from '@emotion/styled';
import type { WWeddingThemeCustomizationView } from '@zola/svc-web-api-ts-client';

import { getBackgroundColorOverride } from 'pages/publicStyleUtils/background.styles';
import { getBodyFontOverride } from 'pages/publicStyleUtils/body.styles';
import { getHeaderFontOverride } from 'pages/publicStyleUtils/header.styles';
import { getFooterStyles } from 'pages/publicStyleUtils/footer.styles';
import { getRegistryPageOverride } from 'pages/publicStyleUtils/registryPageOverride.styles';
import {
  getButtonOverride,
  getGenericOverride,
  getIconStyling,
  getConditionalColorOverride,
} from 'pages/publicStyleUtils/utils.styles';

export type StyledPublicWrapperProps = {
  backgroundColor?: string | null;
  headerFontFamily?: string | null;
  headerFontColor?: string | null;
  bodyFontFamily?: string | null;
  bodyFontColor?: string | null;
  defaultValues?: WWeddingThemeCustomizationView;
  bannerShown?: boolean;
};

export const StyledPublicWrapper = styled.div<StyledPublicWrapperProps>`
  ${({ backgroundColor }) => backgroundColor && getBackgroundColorOverride(backgroundColor)}
  ${({ headerFontColor, headerFontFamily }) =>
    getHeaderFontOverride(headerFontColor, headerFontFamily)}
  ${({ bodyFontColor, bodyFontFamily }) => getBodyFontOverride(bodyFontColor, bodyFontFamily)}
  ${getGenericOverride()}
  ${({ backgroundColor, headerFontColor, bannerShown }) =>
    getIconStyling(backgroundColor, headerFontColor, bannerShown)}
  ${({ backgroundColor }) => getFooterStyles(backgroundColor)}
  ${({ backgroundColor, bodyFontColor, bodyFontFamily, defaultValues }) =>
    getButtonOverride(bodyFontColor, backgroundColor, bodyFontFamily, defaultValues)}
  ${({ backgroundColor, bodyFontColor, defaultValues }) =>
    getConditionalColorOverride(backgroundColor, bodyFontColor, defaultValues)}
  ${({ backgroundColor }) => getRegistryPageOverride(backgroundColor)}
`;
